module.exports = new __parcel__URL__("4.b4d32ae3.webp").toString();